import api from 'service/api'

const dponetAPI = api.create('guestPortal', false)

const getCompanyInfo = async (token) => {
  return await dponetAPI.get('/company_info', { params: { token } })
}

const validateDocument = async (token, document, recaptcha) => {
  return await dponetAPI.post('/validate_document', {
    token,
    document,
    recaptcha,
  })
}

const validateEmail = async (
  token,
  email,
  guestModule,
  publicPath,
  recaptcha,
) => {
  return await dponetAPI.post('/validate_email', {
    token,
    email,
    guestModule,
    publicPath,
    recaptcha,
  })
}

export default {
  getCompanyInfo,
  validateEmail,
}
